import { TeamsInterface } from '@/types/generated/graphql';
import { AppAvatar } from '@components/app-avatar';
import { Tooltip } from 'antd';

export function MobileTeamCard(team: TeamsInterface) {
  return (
    <Tooltip placement="right" title={team?.name} align={{ offset: [24, 0] }}>
      <span className="inline-flex">
        <AppAvatar className="size-9! border-gray-500!" shape="circle" name={team?.name} />
      </span>
    </Tooltip>
  );
}
